module.exports = __webpack_public_path__ + "assets/coloredamex-a7274c.svg";